export const defaultConfig = {
  breakpoints: { small: '480px', medium: '768px', large: '1024px' },
  media_type: 'video',
  selected_media: '0',
  colors: {
    primary: '#00388344',
    secondary: '#ec077544',
    gradient: ['#108AD855', '#ec077555', '#00388355'],
    play_button: '#ffffff',
    play_button_bg: 'rgba(0, 0, 0, 0.9)',
  },
  styles: {
    rootStyles: {},
    widget: {
      small: {
        width: '100px',
        height: '100px',
        size: 10,
        start_y: 130,
        start_x: -43,
        min_x: -43,
        min_y: 130,
        max_y_from_bottom: 130,
      },
      medium: {
        width: '150px',
        height: '150px',
        size: 18,
        start_y: 180,
        start_x: -40,
        min_x: -40,
        min_y: 180,
        max_y_from_bottom: 180,
      },
      large: {
        width: '150px',
        height: '150px',
        size: 18,
        start_y: 180,
        start_x: -40,
        min_x: -40,
        min_y: 180,
        max_y_from_bottom: 180,
      },
      height: '150px',
      width: '150px',
      size: 18,
    },
    widget_controls: { height: '200px', width: '200px' },
    play_button: { small: 15, medium: 15, large: 15 },
    media: [
      {
        transform: 'scale(1.0)',
        position: 'static',
      },
      {
        transform: 'scale(1.9)',
        position: 'relative',
      },
    ],
    image: [
      {
        width: '150px',
        height: '150px',
        position: 'static',
        transform: 'scale(0.8)',
      },
    ],
  },
  widget_type: 'video',
  components: {
    controls: { enabled: false },
    powered_by: {
      'fr-FR': 'AI générée par',
      'en-US': 'Powered by',
      small: { fontSize: '10px' },
      medium: { fontSize: '10px' },
      large: { fontSize: '10px' },
    },
    powered_by_brand: 'Libertify',
    powered_by_link: 'https://www.libertify.com',
    play_button: { 'fr-FR': 'LECTURE', 'en-US': 'PLAY' },
    progress_bar: { enabled: true },
  },
  actions: {
    END_OF_MEDIA: [],
  },
  bracket_override_enabled: false,
  analytics_enabled: false,
  features: {
    scroll_to_bottom_at_start: true,
  },
};
